import React, { useCallback, useEffect, useState } from 'react'
import { Box, Button ,Card, Select , MenuItem, TextField, Typography, Breadcrumbs} from '@mui/material'
import { Col, Container, Row , } from 'react-bootstrap'
import { authPost } from '../../utility/apiConfig'
import { API_BASE_URL } from '../../utility/apiConstants'
import star from '../../assets/images/star.svg'
import '../flights/flight-booking/flight-summary/flightsummary.css'
import PropTypes from 'prop-types'
import './hoteldetail.css'
import Header from '../header/Header'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import starinactive from '../../assets/images/starinactive.svg'
import GuestDetails from './GuestDetails'
import HotelFare from './HotelFare'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
})

function TabPanel (props) {
    const { children, value, index } = props
  
    return (
          <div
              role="tabpanel"
              hidden={value !== index}
              id={`full-width-tabpanel-${index}`}
              aria-labelledby={`full-width-tab-${index}`}
          >
              {value === index && (
                  <Box className="tabboxhotel">
                      <Box>{children}</Box>
                  </Box>
              )}
          </div>
    )
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  }
  
  function ActivityTabPanel (index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`
    }
  }


const HotelBooking = (props) => {
    const [value, setValue] = useState(1)
    const [hotelBookingData, setHotelBookingData] = useState(null)
    const [reviewState, setReviewState] = useState(false)

    const handleReview = () => {
      setReviewState(!reviewState)
    }
    const handleTabinChange = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {

        authPost(API_BASE_URL + 'hotel/booking/')
          .then((response) => {
            if (response.data) {
              setHotelBookingData(response.data)
            } else {
              setHotelBookingData(null)
            }
          })
          .catch((error) => {
            setHotelBookingData(null)
          })
      }, [])

    return <>
          <Container className='selectactivity-container'>
              
            <Row>
                <Col xs={12} sm={12} md={8} lg={8} className="colspace act-select-wrapper">
                    <Row  className="hotelrow">
                    <Col xs={4} md={2}>
                            <div className="actbooking-img-1"><img src="https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351607/Domestic Hotels/Hotels_Coorg/Paddington Resort/pool.jpg" alt=""></img></div>
                        </Col>

                        <Col xs={8} md={10}>
                            <Box className="hoteldtlstag">
                                <div className="tlthotelwithstr">
                                    <h5 className="">Paddington Resort and Spa</h5>
                                    <div className="tltstr">
                                        <ul>
                                            <li><img src={star} alt="star" className="starico"></img></li>
                                            <li><img src={star} alt="star" className="starico"></img></li>
                                            <li><img src={star} alt="star" className="starico"></img></li>
                                            <li><img src={star} alt="star" className="starico"></img></li>
                                            <li><img src={starinactive} alt="star" className="starico"></img></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="hoteladdress"><p><LocationOnIcon />   7th Hosakote, Thondoor Village,Suntikoppa Post, Somwarpet, Kodagu, Kushalnagar , Coorg, India</p></div>
                            
                                <Row>
                                    <Col xs={12} md={3} >
                                        <Box className='info-box'>
                                            <p className='xs-txt-p'>Room Category</p>
                                            <p className='actfare-ttl-bold mt-0'>Bliss</p>
                                        </Box>
                                    </Col>
                                    <Col xs={12} md={3}>
                                        <Box className='info-box'>
                                            <p className='xs-txt-p'>Check-in</p>
                                            <p className='actfare-ttl-bold mt-0'>12:00 PM, 12 Jan</p>
                                        </Box>
                                    </Col>
                                    <Col xs={12} md={3}>
                                        <Box className='info-box'>
                                            <p className='xs-txt-p'>Check-out</p>
                                            <p className='actfare-ttl-bold mt-0'>12:00 PM, 12 Jan</p>
                                        </Box>
                                    </Col>

                                    <Col xs={12} md={3} >
                                        <Box>
                                            <p className='xs-txt-p'>For</p>
                                            <p className='actfare-ttl-bold mt-0'>2 Aduts | 1 Child</p>
                                        </Box>
                                    </Col>
                                </Row>
                            </Box>
                        </Col>
                    </Row>

                    <GuestDetails
                    hotelBookingData={hotelBookingData}
                    searchData={hotelBookingData && hotelBookingData.search_data}
                    reviewHandle={handleReview}
                    isReview={reviewState}
                    bookingDatas={hotelBookingData}
                    />

                    

                    {/* <Row  className="">
                        <Col xs={12}>
                            <Box className="travellerdetailsBox">
                                <div class="three"><h1>Traveller Details </h1></div>
                                <Row className="inputFieldBox">
                                    
                                    <Col xs={12} sm={12} md={2} lg={2} xl={2}>
                                        <Box className="tlt-input-traveller">Title</Box>
                                        <Box className="setinputBox">
                                            <Select
                                            className="dropdownssrinput"
                                            id="standard-select-title"
                                            variant="outlined"
                                            size="small"
                                            >
                                                <MenuItem value="miss">Miss</MenuItem>
                                                <MenuItem value="mr">Mr.</MenuItem>
                                                <MenuItem value="mrs">Mrs.</MenuItem>
                                            </Select>
                                        </Box>
                                    </Col>
                                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <Box className="tlt-input-traveller">First Name</Box>
                                        <Box className="setinputBox">
                                            <TextField variant="outlined"
                                            size="small"
                                            className="inputboxdetails"
                                            placeholder="First Name"
                                            
                                            />
                                        </Box>
                                    </Col>
                                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <Box className="tlt-input-traveller">Last Name</Box>
                                        <Box className="setinputBox">
                                            <TextField variant="outlined"
                                            size="small"
                                            className="inputboxdetails"
                                            placeholder="Last Name"
                                            />
                                        </Box>
                                    </Col>
                                </Row>
                                

                                <div class="three mt-5"><h1>Contact Details </h1></div>

                                <Row className="inputFieldBox">
                                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Box className="setinputBox">
                                        <Box className="tlt-input-traveller">Mobile Number</Box>
                                        <Box className="flexBoxdiv">
                                        <Select 
                                            className="countrycode"
                                            id="standard-select-title"
                                            variant="outlined"
                                            size="small"
                                        >
                                            <MenuItem value="+91">+91</MenuItem>
                                        </Select>

                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            className="inputboxdetails"
                                            placeholder="Mobile Number"
                                            
                                        />
                                        </Box>
                                    </Box>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Box className="setinputBox ">
                                        <Box className="tlt-input-traveller">Email Address</Box>
                                        <TextField variant="outlined" size="small" className="inputboxdetails"
                                        placeholder="Email Address"
                                        
                                        />
                                    </Box>

                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <Box className="setinputBox mt-2">
                                            <Box className="tlt-input-traveller">Address</Box>
                                            <TextField variant="outlined" size="small" className="inputboxdetails"
                                            placeholder="Enter your address here"
                                            
                                            />
                                        </Box>
                                    </Col>
                                </Row>
                            </Box>
                        </Col>
                    </Row> */}
                </Col>
                
                <Col xs={12} sm={12} md={4} lg={4} className="colspace sticky-parent">
                    <HotelFare />
                </Col>
            </Row>
            
        </Container>
  </>
}

export default HotelBooking